import { render, staticRenderFns } from "./NovaSelect.vue?vue&type=template&id=26892ea8&"
import script from "./NovaSelect.vue?vue&type=script&lang=js&"
export * from "./NovaSelect.vue?vue&type=script&lang=js&"
import style0 from "./NovaSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports